import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { useHistory } from "react-router-dom";
import { normalColumn, actionEditColumn, perfixLineColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

import PCIADialog from "../../CIA/PCIADialog.js";
import { ciaCameraNameInfo } from "../../../service/CIA/CiaService";

export default function P200List({ dataTable, searchData, goPage, setLoading, setErrData, showMessages, userId }) {

    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const [multiSortMeta, setMultiSortMeta] = useState([]); //{ field: 'requestType', order: -1 }
    const history = useHistory();

    const [dialog, setDialog] = useState({
        open: false,
        action: "",
    });

    const [dataSet, setDataSet] = useState({});

    const headerLabel = <span className="hidden-responsive">เพิ่มงานสั่งการเฉพาะอย่าง</span>;
    const headerSrhLabel = <span className="hidden-responsive">ค้นหาใบแจ้งฯ</span>;
    const header = (
        <div className="table-header">
            <Button
                className="p-button p-button-success btn-hidden-responsive"
                label={headerLabel}
                icon="pi pi-plus"
                // onClick={() => setDialog({ dialog: true, action: 'บันทึก' })}
                onClick={() => {
                    history.push({
                        pathname: "/207",
                        state: { orderNo: "", page: "200", action: "NEW" },
                    });
                }}
            />
            <Button
                className="p-button btn-hidden-responsive span-responsive"
                label={headerSrhLabel}
                icon="pi pi-search"
                // onClick={() => setDialog({ dialog: true, action: 'บันทึก' })}
                onClick={() => {
                    history.push({
                        pathname: "/205",
                        state: { dataSrh: searchData },
                    });
                }}
                autoFocus
            />
        </div>
    );

    // const actionBodyEdit = (rowData) => goPage(rowData);

    const onMultiSort = (e) => {
        const eventSort = e.multiSortMeta[0];
        const multiSort = [...multiSortMeta];
        const editIndex = multiSort.findIndex((item) => {
            return item.field === eventSort.field;
        });

        if (editIndex > -1) {
            if (multiSort[editIndex].second) {
                multiSort.splice(editIndex, 1);
                setMultiSortMeta(multiSort);
            } else {
                multiSort[editIndex] = { ...eventSort, second: "Y" };
                setMultiSortMeta(multiSort);
            }
        } else {
            multiSort.push(eventSort);
            setMultiSortMeta(multiSort);
        }
    };

    const allaction = (rowData) => {
        let buttonIcon = rowData && rowData.buttonIcon ? rowData.buttonIcon : "";
        let buttonTooltip = rowData && rowData.buttonTooltip ? rowData.buttonTooltip : "";
        let ciaCameraId = rowData && rowData.ciaCameraId ? rowData.ciaCameraId : "";
        let isDisabled = true,
            buttonShowIcon = "pi pi-pencil",
            btnClass = "btn-success";

        if (buttonIcon !== "") {
            switch (buttonIcon) {
                case "View": {
                    buttonShowIcon = "pi pi-eye";
                    btnClass = "p-button-help";
                    break;
                }
                case "Report": {
                    buttonShowIcon = "pi pi-file";
                    btnClass = "p-button-secondary";
                    break;
                }
                case "Input": //{ break;}
                default:
                    break;
            }
        } else {
            isDisabled = false;
        }

        let labelEditShow = <span className="show-responsive">{buttonTooltip}</span>;

        const rowData_2 = { ...rowData, functionId: "260" };





        return (
            <>
                <React.Fragment>
                    <div style={{ textAlign: "center" }}>
                        {isDisabled && (
                            <Button
                                icon={buttonShowIcon}
                                // style={{ backgroundColor: "#1a6a37", border: "1px solid #1a6a37" }}
                                className={`p-button ${btnClass} btn-label-responsive btn-md-responsive p-mr-2 p-mb-2 `}
                                onClick={() => goPage(rowData)}
                                // disabled={isDisabled}
                                tooltip={buttonTooltip}
                                tooltipOptions={{ position: "top" }}
                                label={labelEditShow}
                            />
                        )}
                        {/* new 14/02/2022 */}
                        <Button
                            icon="fa fa-history"
                            // style={{ backgroundColor: "#1a6a37", border: "1px solid #1a6a37" }}
                            className={`p-button p-button-secondary btn-label-responsive btn-md-responsive p-mr-2 p-mb-2 `}
                            onClick={() => goPage(rowData_2)}
                        // disabled={isDisabled}
                        // tooltip={buttonTooltip}
                        // tooltipOptions={{ position: "top" }}
                        // label={labelEditShow}
                        />

                      <Button icon="pi pi-folder" 
                        className="p-button-warning p-button btn-label-responsive btn-md-responsive p-mr-2 p-mb-2" 
                        onClick={() => onOpenDialog(rowData)} 
                        tooltip="ข้อมูลกล้องจากระบบ CIA" 
                        tooltipOptions={{ position: "top" }} 
                        disabled={ciaCameraId === "" ? true : false}/>
                    </div>
                </React.Fragment>
            </>
        );
    };

    const normalColumnFilter = (rowData, checkColumn, titleShow) => {
        let data = { ...rowData };
        let datavalue = data[`${checkColumn}`];

        const _f = datavalue === "C" || datavalue === "M" ? datavalue : "";

        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                {_f && datavalue !== "" && _f !== "null" ? _f : "-"}
            </React.Fragment>
        );
    };




    const onOpenDialog = (data) => {
        onGetDataInfo(data);
        
    }

    const onGetDataInfo = async (data) => {
        setLoading(true);
        console.log("ciaCameraId we: ", data)
   
            let req = {
                cameraCode : data.ciaCameraId,
                userId: userId,
            };
    
            await ciaCameraNameInfo(req).then(
                (res) => {
                    setLoading(false);
                    console.log("dataList : ", res.data)
                    if (res.data !== null) {
                        setDialog({ open: true , action: "U"});
                        setDataSet(res.data);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
       
    };

    return (
        <div className="datatable-responsive-modify">
            <div className="card" style={{ padding: "0rem" }}>
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    header={header}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    sortMode="multiple"
                    multiSortMeta={multiSortMeta}
                    onSort={(e) => onMultiSort(e)}
                    responsiveLayout="scroll"
                    selectionMode="single"
                >
                    {/* <Column field="ownerType" header="ต้นเรื่อง" body={(e) => normalColumnFilter(e, "ownerType", "ต้นเรื่อง")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} /> */}
                    <Column sortable field="requestNo" header="เลขที่ใบแจ้งฯ" body={(e) => normalColumn(e, "requestNo", "เลขที่ใบแจ้งฯ")} style={{ textAlign: "center", width: "7%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="contractNo" header="เลขที่สัญญา" body={(e) => normalColumn(e, "contractNo", "เลขที่สัญญา")} style={{ textAlign: "center", width: "7%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column field="routeName" header="เส้นทาง" body={(e) => normalColumn(e, "routeName", "เส้นทาง")} style={{ textAlign: "center"}} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="requestTypeDesc" header="ประเภทงาน" body={(e) => normalColumn(e, "requestTypeDesc", "ประเภทงาน")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column field="requestCaseDesc" header="ลักษณะงาน" body={(e) => perfixLineColumn(e, "requestCaseDesc", "ลักษณะงาน")} style={{  textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="requestDate" header="วันที่ใบแจ้ง" body={(e) => perfixLineColumn(e, "requestDate", "วันที่ใบแจ้ง")} style={{ textAlign: "center", width: "6%"}} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column field="requestLocation" header="บริเวณก่อสร้าง" body={(e) => normalColumn(e, "requestLocation", "บริเวณก่อสร้าง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="requestPeriod" header="ช่วงเวลาปฏิบัติงาน" body={(e) => normalColumn(e, "requestPeriod", "ช่วงเวลาปฏิบัติงาน")} style={{ textAlign: "center", width: "9%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column field="foremanName" header="หัวหน้างาน" body={(e) => normalColumn(e, "foremanName", "หัวหน้างาน")} style={{ textAlign: "center"}} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="requestStatus" header="สถานะใบแจ้งฯ" body={(e) => normalColumn(e, "requestStatus", "สถานะใบแจ้งฯ")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />

                    <Column
                        header="แก้ไข"
                        body={(e) => allaction(e)}
                        // body={(e) => actionEditColumn(e, actionBodyEdit)}
                        style={{ textAlign: "center", width: "8%" }}
                        bodyStyle={bodyStyle.TXT_CENTER}
                    ></Column>
                </DataTable>
            </div>
            <PCIADialog dialog={dialog} setDialog={setDialog} dataSet={dataSet}></PCIADialog>
        </div>
    );
}
